/** Error that's thrown when a request is made but a carrier has not been chosen */
export default class CarrierNotSelectedError extends Error {}
